import { combineReducers } from 'redux';
import { reducer as notifReducer } from 'redux-notifications';
// import undoable, { includeAction } from 'redux-undo';

import modalReducer from './modal';
import designReducer from './design';
import progressReducer from './progress';
import errorReducer from './errors';
import globalReducer from './global';
// import { undoableActions } from '../actions/design';

export default combineReducers({
  modals: modalReducer,
  notifs: notifReducer,
  errors: errorReducer,
  global: globalReducer,
  design: designReducer,
  progress: progressReducer,
  // undoGroup: undoable(
  //   combineReducers({
  //     design: designReducer,
  //     progress: progressReducer,
  //   }), {
  //     filter: includeAction(undoableActions),
  //     debug: process.env.NODE_ENV !== 'production',
  //     undoType: 'UNDO_COUNTER',
  //     redoType: 'REDO_COUNTER',
  //   }),
});



// WEBPACK FOOTER //
// ./src/reducers/index.js